import { render } from "./PrintDocumentDialog.vue?vue&type=template&id=374cc30c&scoped=true&ts=true"
import script from "./PrintDocumentDialog.vue?vue&type=script&lang=ts"
export * from "./PrintDocumentDialog.vue?vue&type=script&lang=ts"

import "./PrintDocumentDialog.vue?vue&type=style&index=0&id=374cc30c&scoped=true&lang=css"

import exportComponent from "/builds/weleaf/twd-origination-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-374cc30c"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
